const SCENE_CONFIG = {
  backgroundColor: 0xfdfcf9,
  antialias: false,
  fxaaPass: false,
  maxPixelRatio: 2,
  isMobile: false,
  outlinePass: {
    enabled: true,
    color: '#951c32',
    edgeGlow: 1,
    edgeStrength: 4,
    edgeThickness: 1,
    pulsePeriod: 4,
  },
};

export default SCENE_CONFIG;
